module.exports = __webpack_public_path__ + "static/media/check-circle.5035d64d.svg";